import Vue from "vue"
import axios from "axios"
import VueAxios from "vue-axios"
import JwtService from "@/core/services/jwt.service"

/**
 * Service to call HTTP request via Axios
 */

const env = process.env
const baseUrlApiSass = env.VUE_APP_API_SAAS_ENDPOINT

const handleRequestError = (error) => {
  return Promise.reject(error);
};

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  setTenantConfig(tenantConfig) {
    Vue.axios.defaults.headers.common[
      "hostip"
    ] = tenantConfig.database_ip;

    Vue.axios.defaults.headers.common[
      "name"
    ] = tenantConfig.database_name;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(handleRequestError);
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, slug = "") {
    return Vue.axios.get(`${baseUrlApiSass}${resource}${slug}`).catch(handleRequestError);
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    return Vue.axios.post(`${baseUrlApiSass}${resource}`, params).catch(handleRequestError);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {Promise<any>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${baseUrlApiSass}${resource}${slug}`, params).catch(handleRequestError);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {Promise<any>}
   */
  put(resource, params) {
    return Vue.axios.put(`${baseUrlApiSass}${resource}`, params).catch(handleRequestError);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource).catch(handleRequestError);
  }
};

export default ApiService;
